import { inject, Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private spinner = inject(NgxSpinnerService);
  private activeRequests = 0;

  show() {
    if (this.activeRequests === 0) {
      this.spinner.show();
    }
    this.activeRequests++;
  }

  hide() {
    this.activeRequests--;
    if (this.activeRequests <= 0) {
      this.activeRequests = 0;
      this.spinner.hide();
    }
  }
}
